<div class="breadcrumb">
  <div class="container">
    <a routerLink="/">Home</a> > <a routerLink="/grupo-lista">{{ 'Lista de grupos' | translate}}</a> > {{ 'Detalhe do Grupo' | translate}}
  </div>
</div>

<main class="container">

  <!-- Cabeçalho da página -->
  <div class="page-header flex space-between">
    <h1>
      {{ 'Detalhe do Grupo' | translate }}: {{ nomeGrupo }}
      <span *ngIf="!isInclusao" class="status-badge"
            [class.ativo]="dadosGrupo.isActive !== false"
            [class.inativo]="dadosGrupo.isActive === false">
        {{ dadosGrupo.isActive !== false ? ('Ativo' | translate) : ('Inativo' | translate) }}
      </span>
    </h1>
    <div class="filtro">
      <label>&nbsp;</label>
      <button class="red_button padding" (click)="back()">{{ 'Voltar' | translate }}</button>
    </div>
  </div>

  <!-- Card 1: Dados do Grupo -->
  <div class="section-card">
    <div class="section-header">
      <h3>{{ 'Dados do Grupo' | translate }}</h3>
    </div>
    <div class="section-body">
      <div class="flex form filtros">
        <div class="form-group filtro">
          <label for="groupName">{{ 'Nome do Grupo' | translate }}</label>
          <input type="text" id="groupName" class="form-control" [(ngModel)]="nomeGrupo">
        </div>
        <div class="form-group filtro">
          <label>&nbsp;</label>
          <button class="red_button" (click)="gravarGrupo()">{{ 'Salvar' | translate }}</button>
        </div>
        <div class="form-group filtro" *ngIf="!isInclusao">
          <label>&nbsp;</label>
          <button *ngIf="dadosGrupo.isActive !== false" class="red_button" (click)="toggleActiveGroup(false)">{{ 'Desativar Grupo' | translate }}</button>
          <button *ngIf="dadosGrupo.isActive === false" class="dark_button" (click)="toggleActiveGroup(true)">{{ 'Reativar Grupo' | translate }}</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Card 2: Países e Regiões -->
  <div class="section-card" *ngIf="showAddGroup">
    <div class="section-header flex space-between">
      <h3>{{ 'Países e Regiões' | translate }}</h3>
      <button *ngIf="!isInclusao" class="toggle-section-btn"
              (click)="showAddAssocForm = !showAddAssocForm">
        {{ showAddAssocForm ? ('▲ ' + ('Fechar formulário' | translate)) : ('+ ' + ('Adicionar associação' | translate)) }}
      </button>
    </div>
    <div class="section-body">

      <!-- Formulário de nova associação (controlado por showAddAssocForm) -->
      <div class="add_group" *ngIf="showAddAssocForm">
        <div class="flex form filtros">
          <div class="form-group filtro">
            <label for="newCountry">{{ 'País' | translate }}:</label>
            <select id="newCountry" class="form-control" [(ngModel)]="newAssociation.countryId" (change)="carregaFiltroRegioes($event)">
              <option value="" disabled selected>{{ 'Selecione um País' | translate }}</option>
              <option *ngFor="let pais of listaPaises" [value]="pais.id">{{pais.name}}</option>
            </select>
          </div>
          <div class="form-group filtro">
            <label for="newRegion">{{ 'Região' | translate }}:</label>
            <select id="newRegion" class="form-control" [(ngModel)]="newAssociation.regionId">
              <option value="" selected>{{ 'Todas' | translate }}</option>
              <option *ngFor="let regiao of listaRegiao" [value]="regiao.id">{{regiao.name}}</option>
            </select>
          </div>
          <div class="form-group filtro">
            <label for="newWeight">{{ 'Volume' | translate }} %:</label>
            <input type="number" id="newWeight" class="form-control" [(ngModel)]="newAssociation.weight" appNumeroDe1a100>
          </div>
          <div class="form-group filtro">
            <label>&nbsp;</label>
            <button class="red_button" (click)="adicionarAssociacao()">{{ 'Adicionar' | translate }}</button>
          </div>
        </div>
      </div>

      <!-- Tabela de associações — sempre visível dentro do card -->
      <div class="table-container">
        <table border="0" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th>{{ 'País' | translate }}</th>
              <th>{{ 'Região' | translate }}</th>
              <th width="200px">{{ 'Volume' | translate }} %</th>
              <th>{{ 'Qtd usuários' | translate }}</th>
              <th class="text-center">{{ 'Ações' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let gcr of groupCountryRegions">
              <td>{{gcr.countryName}}</td>
              <td>{{gcr.regionName}}</td>
              <td>
                <input type="number" class="form-control" [(ngModel)]="gcr.weight" appNumeroDe1a100>
              </td>
              <td><span style="align-content: center !important;">{{gcr.userMembers}}</span></td>
              <td class="text-center">
                <a (click)="removeGroupCountryRegion(gcr)" class="dark_button" title="{{ 'Remover' | translate }}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                </a>
                <a (click)="adicionarUsuarioaGrupo(gcr.idGrupoRegion); $event.stopPropagation();" class="light_button" title="{{ 'Gerenciar usuários' | translate }}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h12a2 2 0 0 0 2-2V8l-6-6z"/><path d="M14 3v5h5M16 13H8M16 17H8M10 9H8"/></svg>
                </a>
                <a (click)="exportarUsuariosGrupo(gcr); $event.stopPropagation();" class="light_button" title="{{ 'Exportar usuários' | translate }}">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="button-group">
        <button class="red_button padding" (click)="saveAssociations()">{{ 'Salvar' | translate }}</button>
      </div>

    </div>
  </div>

  <!-- Card 3: Responsáveis pelo Grupo (inline — sem modal) -->
  <div class="section-card" *ngIf="!isInclusao">
    <div class="section-header">
      <h3>{{ 'Responsáveis pelo Grupo' | translate }}</h3>
    </div>
    <div class="section-body">
      <div class="flex form filtros">
        <div class="form-group filtro">
          <label for="userSelectResp">{{ 'Selecione um usuário' | translate }}</label>
          <select id="userSelectResp" class="form-control" [(ngModel)]="newResponsible.idUser">
            <option value="" disabled selected>{{ 'Selecione um usuário' | translate }}</option>
            <option *ngFor="let user of usersList" [value]="user.id">{{user.email}}</option>
          </select>
        </div>
        <div class="form-group filtro">
          <label>&nbsp;</label>
          <button class="red_button" (click)="addUserResponsible()">{{ 'Adicionar Responsável' | translate }}</button>
        </div>
      </div>

      <div class="table-container" *ngIf="!isAdminGrupoUser && groupUserResponsible.length > 0">
        <table border="0" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <th>#</th>
              <th>{{ 'Email' | translate }}</th>
              <th>{{ 'Ações' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of groupUserResponsible; let i = index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.userEmail }}</td>
              <td>
                <a (click)="removeUserResponsible(item)" class="dark_button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

</main>

<!-- Modal: Gerenciar usuários da associação País/Região (mantido como modal — contextual por linha da tabela) -->
<div class="modal modal1" tabindex="-1" role="dialog" *ngIf="isModal1Open">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header flex space-between">
        <h5 class="modal-title">{{ 'Associar usuário ao grupo' | translate }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="closeModal1()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group filtro">
          <label for="userSelect">{{ 'Selecione o usuário' | translate }}:</label>
          <select id="userSelect" class="form-control" [(ngModel)]="selectedUserId">
            <option value="" disabled selected>{{ 'Selecione um usuário' | translate }}</option>
            <option *ngFor="let user of availableUsers" [value]="user.id">{{user.email}}</option>
          </select>
        </div>
        &nbsp;
        <div class="form-group">
          <div class="table-container">
            <table border="0" cellpadding="0" cellspacing="0">
              <thead>
                <tr>
                  <th>#</th>
                  <th>{{ 'Email' | translate }}</th>
                  <th>{{ 'Ações' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of listaShowItensUsers | paginate: { itemsPerPage: pageSize, currentPage: currentPage, totalItems: totalItems }; let i = index">
                  <td>{{ (currentPage - 1) * 15 + i + 1 }}</td>
                  <td>{{ item.email }}</td>
                  <td>
                    <a (click)="removeOfGrupo(item)" class="dark_button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="red_button padding" (click)="associateUser()">{{ 'Associar' | translate }}</button>
        <button class="red_button padding" (click)="closeModal1()">{{ 'Fechar' | translate }}</button>
      </div>
    </div>
  </div>
</div>
